<template>
  <div class="scroll-wrapper">
    <div class="to-left-btn" @click="scrollToLeft" v-if="scrollLeftLength > 50">
      <span class="line-left"></span>
      <svg
        t="1638924303599"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="1219"
        width="42"
        height="42"
      >
        <path
          d="M242.6026663 512L725.3333333 29.269333l64 64L370.6026663 512 789.3333333 930.730667l-64 64L242.6026663 512z"
          fill="#bababa"
          p-id="1220"
        ></path>
      </svg>
    </div>
    <div v-if="meetings.length > 0" class="wrapper" ref="scrollView">
      <div
        class="card"
        v-for="meeting in meetings"
        :key="meeting.id"
        @click="toMeetingDetail(meeting)"
      >
        <div class="head">
          <div class="left">
            <div class="loading-container">
              <span class="loading-line"></span>
              <span class="loading-line"></span>
              <span class="loading-line"></span>
              <span class="loading-line"></span>
              <span class="loading-line"></span>
            </div>
            直播中
          </div>
          <div class="watching-count">
            {{ meeting.pv }}
            <el-icon :size="24">
              <img
                style="width: 24px"
                src="../../assets/img/case/see_new.png"
                alt=""
              />
            </el-icon>
          </div>
        </div>
        <div class="body">会议地点：{{ meeting.area_name }}</div>
        <div class="divider"></div>
        <div class="footer">
          {{ meeting.title }}
        </div>
      </div>
    </div>
    <div v-else>
      <el-empty description="暂时没有直播哦~"></el-empty>
    </div>
    <div
      class="to-right-btn"
      @click="scrollToRight"
      v-if="scrollLeftLength + 1200 < scrollWidth"
    >
      <svg
        t="1638924349593"
        class="icon"
        viewBox="0 0 1024 1024"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        p-id="1410"
        width="42"
        height="42"
      >
        <path
          d="M332.1856 68.9152h-21.7088l-50.8928 50.8928v21.7088L630.0672 512 259.584 882.4832v21.7088l50.8928 50.8928h21.7088l432.128-432.128v-21.8112z"
          fill="#bababa"
          p-id="1411"
        ></path>
      </svg>
      <span class="line-right"></span>
    </div>
  </div>
</template>

<script lang="ts">
import { ArrowRightBold, ArrowLeftBold } from "@element-plus/icons";
import { defineComponent, nextTick, onMounted } from "vue";
import { ref } from "@vue/reactivity";
import useIndexMeetingPage from "../../hooks/indexMeetingPage/indexMeetingPage";

export default defineComponent({
  components: {
    ArrowRightBold,
    ArrowLeftBold,
  },
  name: "index-live-card",
  props: {
    meetings: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  setup(props) {
    const { toMeetingDetail } = useIndexMeetingPage();
    const scrollView = ref(null);
    const scrollToLeft = async () => {
      await nextTick();
      if (scrollLeftLength.value > 0) {
        scrollLeftLength.value -= 520;
      }
      if (scrollLeftLength.value < 0) {
        scrollLeftLength.value = 0;
      }
      scrollView.value.scrollLeft = scrollLeftLength.value;
    };

    const scrollToRight = async () => {
      await nextTick();
      if (scrollLeftLength.value + 1200 < scrollWidth.value) {
        scrollLeftLength.value += 520;
      }
      scrollView.value.scrollLeft = scrollLeftLength.value;
    };

    const scrollLeftLength = ref(0);
    const scrollWidth = ref(0);
    onMounted(() => {
      scrollWidth.value = scrollView.value.scrollWidth;
    });
    return {
      scrollView,
      scrollLeftLength,
      scrollWidth,
      scrollToLeft,
      scrollToRight,
      toMeetingDetail,
    };
  },
});
</script>

<style lang="less" scoped>
::-webkit-scrollbar {
  width: 3px;
  height: 6px;
}

/* 滚动槽 */
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
  border-radius: 10px;
}

/* 滚动条滑块 */
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, 0.1);
  -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
}

::-webkit-scrollbar-thumb:window-inactive {
  background: rgba(255, 0, 0, 0.4);
}

.scroll-wrapper {
  width: 1200px;
  box-sizing: border-box;
  position: relative;

  .to-left-btn {
    width: 50px;
    height: 267px;
    background: #f6f6f6;
    border-radius: 30px 0 0 30px;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
    box-shadow: 20px 0 20px 0 rgba(221, 221, 221, 0.5);
    cursor: pointer;
  }

  .to-right-btn {
    width: 50px;
    height: 267px;
    background: #f6f6f6;
    border-radius: 0 30px 30px 0;
    position: absolute;
    right: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 99;
    box-shadow: -20px 0 20px 0 rgba(221, 221, 221, 0.5);
    cursor: pointer;
  }

  .wrapper {
    width: 1200px;
    margin: 20px auto 0 auto;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    overflow: hidden;
    padding: 3px 5px;
    position: relative;
    box-sizing: border-box;
    scroll-behavior: smooth;

    .card {
      flex-shrink: 0;
      width: 500px;
      height: 261px;
      background: #ffffff;
      box-shadow: 2px 1px 14px 0 rgba(0, 0, 0, 0.08);
      border-radius: 32px;
      margin-right: 20px;
      cursor: pointer;

      .head {
        width: 100%;
        height: 38px;
        margin-top: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding-left: 20px;
        padding-right: 20px;
        box-sizing: border-box;

        .left {
          width: 146px;
          height: 38px;
          background: #05C064;
          border-radius: 18px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-sizing: border-box;
          color: white;
          padding-left: 20px;
          padding-right: 20px;
        }

        .watching-count {
          font-size: 18px;
          font-weight: 400;
          color: #545454;
          line-height: 45px;
        }
      }

      .body {
        font-size: 18px;
        font-weight: 400;
        color: #888888;
        box-sizing: border-box;
        padding-left: 20px;
        margin-top: 24px;
      }

      .divider {
        width: 460px;
        height: 1px;
        background: #eeeeee;
        margin: 24px auto;
      }

      .footer {
        box-sizing: border-box;
        padding-bottom: 42px;
        padding-left: 20px;
        padding-right: 20px;
        height: 85px;
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        line-clamp: 4;
        -webkit-box-orient: vertical;
      }
    }
  }
}
</style>

<!--animation-->
<style lang="less">
@import "../../assets/css/animation.css";

.line-left {
  display: inline-block;
  width: 4px;
  height: 34px;
  background: #bababa;
  border-radius: 4px;
  margin-left: 5px;
  position: relative;
  right: -5px;
}

.line-right {
  display: inline-block;
  width: 4px;
  height: 34px;
  background: #bababa;
  border-radius: 4px;
  margin-right: 5px;
  position: relative;
  left: -5px;
}
</style>
